<script>
import Config from "../config.json";
import Countdown from "./Countdown.svelte";

const start = new Date(Config.liveDateTime);
</script>

<div class='flex flex-col items-center border-8 border-[#2C3235] bg-white px-6 py-4 gap-2'>
  <div class='font-bold'>Event Starts In</div>
  <div class='text-2xl font-bold'>
    <Countdown endTime={start} />
  </div>
  <div>Return here on {start.toLocaleString('default', {month: 'long', day: 'numeric'})} @ {start.toLocaleTimeString('default', {hour: 'numeric', minute: '2-digit', hour12: true})} EST for access to exclusive content, schedules and more.</div>
</div>